import React from 'react';
import { AverageSatisfactionKPI, TotalSurveysKPI, BestShiftKPI, BestOrderTypeKPI } from './kpis';
import { TimePeriod } from '../../types/api';

interface KPIsSectionProps {
  branchId?: number;
  timeRange?: TimePeriod;
  onError?: (error: Error) => void;
  showLoading?: boolean;
  compact?: boolean;
}

const KPIsSection: React.FC<KPIsSectionProps> = ({
  branchId = 0,
  timeRange,
  onError,
  showLoading = true,
  compact = false
}) => {
  return (
    <div className={`grid  ${compact ? 'grid-cols-2 gap-2' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'} mb-6 animate-enter`}>
      <AverageSatisfactionKPI
        branchId={branchId}
        timeRange={timeRange}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
      
      <TotalSurveysKPI
        branchId={branchId}
        timeRange={timeRange}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
      
      <BestShiftKPI
        branchId={branchId}
        timeRange={timeRange}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
      
      <BestOrderTypeKPI
        branchId={branchId}
        timeRange={timeRange}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
    </div>
  );
};

export default KPIsSection;